import Cookies from "universal-cookie";
class LinkGenerator {
    constructor(config = {}) {
        this.removeEmptyValues = (obj) => Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== null && v !== undefined));
        this.formatUrl = (params) => {
            const enrichedParams = Object.assign({}, params);
            if (!enrichedParams.mostRecentTraditionalDeviceId) {
                enrichedParams.mostRecentTraditionalDeviceId = this.getDeviceId();
            }
            const urlSearchParams = new URLSearchParams(this.removeEmptyValues(enrichedParams));
            return `${this.path}?${urlSearchParams.toString()}`;
        };
        this.getDeviceId = () => {
            return this.cookies.get("cookie_id");
        };
        this.login = (params) => {
            return this.formatUrl(Object.assign(Object.assign({}, this.config), params));
        };
        this.register = (params) => {
            return this.formatUrl(Object.assign(Object.assign(Object.assign({}, this.config), params), { initialScreen: "signup" }));
        };
        this.appleAuth = (params) => {
            return this.formatUrl(Object.assign(Object.assign({}, params), { connection: "apple" }));
        };
        this.googleAuth = (params) => {
            return this.formatUrl(Object.assign(Object.assign({}, params), { connection: "google-oauth2" }));
        };
        this.progressiveRegistration = (params) => {
            return this.formatUrl(Object.assign(Object.assign({}, params), { progressiveReg: "true" }));
        };
        this.path = "/api/nts/v1/login";
        this.config = config;
        this.cookies = new Cookies();
    }
}
export default LinkGenerator;
//# sourceMappingURL=index.js.map